module.exports = __webpack_public_path__ + "media/images/athletes/599-4c949064032146ef74438f64c8df2150.png";